import type { CvData } from './generate-cv-pdf';
import type { TailorCvResponse } from '../../types/profile-cv-tailor';

/**
 * Merges a sanitized tailoring response onto the user's base CV data. The server is the
 * trust boundary (ids/skills already validated there) — this just applies overrides:
 * swap in a tailored description where the id matches, fall back to the original text
 * otherwise. Never touches company/title/dates — those aren't part of the response shape.
 */
export function buildTailoredCvData(base: CvData, tailoring: TailorCvResponse): CvData {
  const workExperienceOverrides = new Map(tailoring.workExperienceDescriptions.map((e) => [e.id, e.description]));
  const projectOverrides = new Map(tailoring.projectDescriptions.map((p) => [p.id, p.description]));

  return {
    ...base,
    profileTitle: tailoring.profileTitle || base.profileTitle,
    workExperiencesByDate: base.workExperiencesByDate.map((exp) => {
      const override = workExperienceOverrides.get(exp.id);
      return override ? { ...exp, description: override } : exp;
    }),
    projectsByYear: base.projectsByYear.map((proj) => {
      const override = projectOverrides.get(proj.id);
      return override ? { ...proj, description: override } : proj;
    }),
    skills: tailoring.skills.length > 0 ? tailoring.skills : base.skills,
  };
}
